export default {
  props: {
    terms: {
      type: String,
      default: '',
    },
  },

  computed: {
    termsLink() {
      return this.privacyLink ? this.$t('Form.agree', { privacyLink: this.privacyLink }) : '';
    },

    privacyLink() {
      return this.terms
        ? `<a target='_blank' class='rcms_privacypol link link--text' href='${this.terms}'>${this.$t(
            'Form.privacy',
          )}</a>`
        : '';
    },
  },
};
